import { StyleSheet } from 'react-native';

const FooterImageStyle = StyleSheet.create({
    footerImageStyle: { position: 'absolute', bottom: 0, right: 0 }
});

export { FooterImageStyle };
